/**
 * 浏览器脚本加载工具：按 URL 复用加载中的 Promise，避免同一脚本被重复插入页面。
 */

const scriptPromises = new Map<string, Promise<boolean>>()

/**
 * 加载外部脚本。
 *
 * 加载失败时会清理 Promise 缓存，使后续调用可以重新尝试加载。
 */
export const loadScript = (url: string): Promise<boolean> => {
  const existingPromise = scriptPromises.get(url)
  if (existingPromise) return existingPromise

  const promise = new Promise<boolean>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = url
    script.async = true
    script.onload = () => resolve(true)
    script.onerror = () => reject(new Error(`Failed to load script: ${url}`))
    document.head.appendChild(script)
  }).catch((error) => {
    scriptPromises.delete(url)
    throw error
  })

  scriptPromises.set(url, promise)
  return promise
}
